export const AI_ENHANCE_UI = {
  question: {
    title: "Enhance question with AI",
    selectTitle: "Select text to enhance",
    selectDescription:
      "Highlight the question text you want to improve, or type content in the editor first.",
  },
  response: {
    title: "Enhance response with AI",
    selectTitle: "Select text to enhance",
    selectDescription:
      "Highlight the response text you want to improve, or type content in the editor first.",
  },
};

export function getAiEnhanceLabels(target) {
  return AI_ENHANCE_UI[target] || AI_ENHANCE_UI.question;
}
